<template>
  <div>
    <el-row :style='{ width: "100%", height: height}' class="echarts">
      <IEcharts theme="macaron" :option="stackOptions" :notMerge="true" :resizable="true" v-if="stackOptions !== null"/>
    </el-row>
  </div>
</template>

<script>
  import 'echarts/theme/macarons.js';
  import IEcharts from 'vue-echarts-v3/src/full.js';
  import { store } from '../scripts/store.js';
  import { events } from '../scripts/events.js';
  const _ = require('lodash');

  export default {
    name: 'ModalUnitStackAnnoKmerDistribution',
    props: {
        series: Object,
        height: String,
      index: Number
    },
    components: { IEcharts },
    asyncComputed: {
      stackOptions: function () {
				let title = this.series.title;
        if (title === '') { title = { show: false } }
        else { title =  { 
          text: this.series.title, 
          textStyle: { 
            fontSize: 18, 
            fontWeight: 'bold', 
            width: '20%',
            fontFamily: 'Oxygen', 
            }, 
          left: 40, 
        }}
        const series = this.series.data;
        const xAxis = this.series.xAxis;
        const yAxis = this.series.yAxis;

        const options = {
          title: title,
          grid: {
            left: 50,
            top: 90,
            bottom: 50,
            right: 5,
            // containLabel: true
          },
          toolbox: {
            right: 20,
            feature: {
              saveAsImage: { 
                title: 'Save as PNG', 
                show: true, 
                type: 'png', 
                name: `${this.series.title}_AnnoDistribution` 
              },
              dataView: { 
                title: 'View data', 
                readOnly: true, 
                lang: ['Data View', 'Go back'] 
              },
            }
          },
          backgroundColor: 'white',
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            },
            backgroundColor: 'rgba(240, 240, 240, 0.8)',
            textStyle: {
              align: 'left',
              color: 'rgba(50, 50, 50, 0.8)'
            }
          },
          yAxis: yAxis, //{ type: 'value', min: 0, max: 100 },
          xAxis: xAxis, //{ type: 'category', data: xLabels },
          legend: {
            show: true,
            top: '35',
          },
          series: series,
          animation: true,
        }
        
        return new Promise(resolve => setTimeout(() => resolve(options), this.index * store.settings.plotUpdateDelayFactor))
      }
    }
  }
</script>


